const locale = {
  'JsonView.label': 'JSON 查看器',
  'JsonView.searchPlaceholder': '搜索...',
  'JsonView.expand': '展开',
  'JsonView.collapse': '收起',
  'JsonView.expandAll': '展开全部',
  'JsonView.collapseAll': '收起全部',
  'JsonView.items': '项',
  'JsonView.keys': '个键',
  'JsonView.copy': '复制',
  'JsonView.copied': '已复制'
};

export default locale;
